<section class="tab-section">
  <header class="tab-toolbar">
    <div>
      <span class="toolbar-eyebrow">Planeamento semanal</span>
      <h3>Escala dos efetivos do posto</h3>
      <p>{{ totalEfetivos }} efetivo(s) alocados a este posto</p>
    </div>

    <div class="tab-toolbar-actions">
      <button 
        type="button" 
        class="btn-falta-trigger" 
        [disabled]="totalEfetivos === 0"
        (click)="openStandaloneFaltaDrawer()"
      >
        <i class="ri-user-unfollow-line"></i>
        Registar falta
      </button>
      <button type="button" class="btn-web-primary" (click)="openCreateDialog()">
        <i class="ri-calendar-add-line"></i>
        Escalar efetivos
      </button>
    </div>
  </header>

  <app-escala-calendario
    [efetivos]="efetivos"
    [escalas]="escalas"
    [turnos]="turnos"
    [semanaInicio]="semanaInicio"
    [loading]="loading"
    (weekChange)="onWeekChange($event)"
    (slotClick)="handleSlotClick($event)"
    (removeClick)="handleRemoveClick($event)"
    (absenceClick)="handleAbsenceClick($event)"
    (conflictClick)="handleConflictClick($event)"
  ></app-escala-calendario>

  <div class="calendar-paginator" *ngIf="totalEfetivos > 0">
    <div class="calendar-pagination-copy">
      <span><i class="ri-team-line"></i> Efetivos apresentados</span>
      <small>{{ first + 1 }}–{{ first + efetivos.length }} de {{ totalEfetivos }} · navegue para consultar toda a equipa</small>
    </div>
    <app-paginator-control
      [first]="first"
      [rows]="pageSize"
      [totalRecords]="totalEfetivos"
      [rowsPerPageOptions]="[5, 10, 20, 30]"
      [showCurrentPageReport]="true"
      (pageChange)="onPageChange($event)"
    ></app-paginator-control>
  </div>
</section>

<!-- Drawer: Construir Escala -->
<p-drawer
  [(visible)]="showCreateDialog"
  (onHide)="closeCreateDialog()"
  [modal]="true"
  position="right"
  appendTo="body"
  [style]="{ width: '1080px', maxWidth: '98vw' }"
  styleClass="escala-drawer"
>
  <ng-template pTemplate="header">
    <div class="drawer-title">
      <span class="drawer-title-icon">
        <i class="ri-calendar-schedule-line"></i>
      </span>
      <div>
        <h2>Construir escala</h2>
        <p>Organize efetivos por turno e confirme o plano antes de enviar.</p>
      </div>
    </div>
  </ng-template>

  <form class="create-scale-form" [formGroup]="createForm" (ngSubmit)="submitEscala()">
    <div class="drawer-summary-strip">
      <span>
        <i class="ri-team-line"></i>
        {{ pickerSelected.size || 0 }} selecionado(s)
      </span>
      <span>
        <i [class]="selectedTurno ? getTurnoIcon(selectedTurno) : 'ri-time-line'"></i>
        {{ selectedTurno ? getTurnoNome(createForm.value.turnoId) : "Turno por definir" }}
      </span>
      <span>
        <i class="ri-route-line"></i>
        {{ planoEscala.length }} dia(s) no plano
      </span>
    </div>

    <nav class="drawer-stepper" aria-label="Etapas para construir a escala">
      <span [class.active]="!pickerSelected.size" [class.complete]="pickerSelected.size">
        <b><i [class]="pickerSelected.size ? 'ri-check-line' : 'ri-user-add-line'"></i></b>
        <span><strong>Selecionar</strong><small>Escolher efetivos</small></span>
      </span>
      <i class="ri-arrow-right-line"></i>
      <span [class.active]="pickerSelected.size && !planoEscala.length" [class.complete]="planoEscala.length">
        <b><i [class]="planoEscala.length ? 'ri-check-line' : 'ri-settings-3-line'"></i></b>
        <span><strong>Configurar</strong><small>Papel, turno e período</small></span>
      </span>
      <i class="ri-arrow-right-line"></i>
      <span [class.active]="planoEscala.length">
        <b><i class="ri-list-check-3"></i></b>
        <span><strong>Rever e guardar</strong><small>Confirmar o plano</small></span>
      </span>
    </nav>

    <div class="create-grid">
      <section class="create-card">
        <div class="section-heading">
          <span>1</span>
          <div>
            <strong>Selecionar efetivos</strong>
            <small>A lista contém os efetivos alocados a este posto.</small>
          </div>
          <div class="mode-toggle">
            <button
              type="button"
              [class.active]="createMode === 'single'" [attr.aria-pressed]="createMode === 'single'"
              (click)="setCreateMode('single')"
            >
              Individual
            </button>
            <button
              type="button"
              [class.active]="createMode === 'multiple'" [attr.aria-pressed]="createMode === 'multiple'"
              (click)="setCreateMode('multiple')"
            >
              Vários
            </button>
          </div>
        </div>

        <div class="field">
          <label>Pesquisar efetivo</label>
          <label class="search-box">
            <input
              #pickerSearchInput
              type="search"
              placeholder="Pesquisar por nome..."
              [value]="pickerSearch"
              (keydown.enter)="$event.preventDefault()"
              (input)="onPickerSearchInput(pickerSearchInput.value)"
              (keyup.enter)="onPickerSearch(pickerSearchInput.value)"
            />
            <i class="ri-search-line"></i>
            <button *ngIf="pickerSearch" type="button" class="search-clear" aria-label="Limpar pesquisa" (click)="clearPickerSearch()">
              <i class="ri-close-line"></i>
            </button>
          </label>
        </div>

        <div class="picker-list-toolbar" aria-live="polite">
          <span>
            <i [class]="pickerLoading ? 'ri-loader-4-line spin' : 'ri-team-line'"></i>
            <ng-container *ngIf="pickerLoading; else pickerTotalLabel">A carregar efetivos...</ng-container>
            <ng-template #pickerTotalLabel><strong>{{ pickerTotal }}</strong> efetivo(s) encontrado(s)</ng-template>
          </span>
          <small *ngIf="pickerTotal">Página {{ pickerPage }} de {{ pickerTotalPages }}</small>
        </div>

        <div class="picker-list" [attr.aria-busy]="pickerLoading">
          <ng-container *ngIf="pickerLoading; else listaEfetivos">
            <p-skeleton
              *ngFor="let s of pickerSkeletonRows"
              height="46px"
              borderRadius="8px"
            ></p-skeleton>
          </ng-container>

          <ng-template #listaEfetivos>
            <button
              *ngFor="let efetivo of pickerEfetivos"
              type="button"
              class="picker-row"
              [class.selected]="isSelected(efetivo)"
              [class.planned]="isEfetivoPlaneado(efetivo.id)"
              [class.in-turno]="isEfetivoJaNoTurnoSelecionado(efetivo.id)"
              [attr.aria-pressed]="isSelected(efetivo)"
              (click)="toggleEfetivo(efetivo)"
            >
              <span class="picker-check"><i class="ri-check-line"></i></span>
              <span class="picker-avatar">
                <img
                  *ngIf="efetivo.urlFoto"
                  [src]="efetivo.urlFoto"
                  [alt]="efetivo.nome"
                />
                <span *ngIf="!efetivo.urlFoto">{{ getInitials(efetivo.nome) }}</span>
              </span>
              <span class="picker-meta">
                <strong>{{ efetivo.nome }}</strong>
                <small
                  *ngIf="
                    !isEfetivoPlaneado(efetivo.id) &&
                    !isEfetivoJaNoTurnoSelecionado(efetivo.id)
                  "
                >
                  <i class="ri-briefcase-4-line"></i>
                  {{ efetivo.cargo || "Alocado" }}
                  <ng-container *ngIf="efetivo.codigo"> · {{ efetivo.codigo }}</ng-container>
                </small>
                <small *ngIf="isEfetivoPlaneado(efetivo.id)" class="planned-copy">
                  <i class="ri-calendar-check-line"></i>
                  {{ getEfetivoPlanoResumo(efetivo.id) }}
                </small>
                <small
                  *ngIf="
                    !isEfetivoPlaneado(efetivo.id) &&
                    isEfetivoJaNoTurnoSelecionado(efetivo.id)
                  "
                  class="already-copy"
                >
                  <i class="ri-shield-check-line"></i>
                  {{ getEfetivoExistenteResumo(efetivo.id) }}
                </small>
              </span>
            </button>

            <div *ngIf="!pickerEfetivos.length" class="picker-empty">
              <span><i class="ri-user-search-line"></i></span>
              <strong>Nenhum efetivo encontrado</strong>
              <small>{{ pickerSearch ? 'Experimente outro nome ou limpe a pesquisa.' : 'Não existem efetivos alocados disponíveis nesta página.' }}</small>
              <button *ngIf="pickerSearch" type="button" (click)="clearPickerSearch()">Limpar pesquisa</button>
            </div>
          </ng-template>
        </div>

        <div class="picker-selection-summary">
          <div>
            <span><i class="ri-checkbox-circle-line"></i><strong>{{ pickerSelected.size }}</strong> selecionado(s)</span>
            <small *ngIf="pickerSelected.size">A seleção é mantida quando muda de página.</small>
          </div>
          <button *ngIf="pickerSelected.size" type="button" (click)="clearPickerSelection()">Limpar seleção</button>
        </div>

        <div class="picker-paginator" *ngIf="pickerTotal > 0" [class.paginator-disabled]="pickerLoading">
          <app-paginator-control
            [first]="pickerFirst"
            [rows]="pickerPageSize"
            [totalRecords]="pickerTotal"
            [rowsPerPageOptions]="[5, 10, 20]"
            [showCurrentPageReport]="true"
            (pageChange)="onPickerPageChange($event)"
          ></app-paginator-control>
        </div>
      </section>

      <section class="create-card">
        <div class="section-heading">
          <span>2</span>
          <div>
            <strong>Configurar alocação</strong>
            <small>Defina papel, turno e dias para os selecionados.</small>
          </div>
        </div>

        <div class="field">
          <label>Papel na escala</label>
          <div class="papel-options">
            <button
              *ngFor="let papel of papeisEscala"
              type="button"
              class="papel-option"
              [class.selected]="papelSelecionado === papel.value" [attr.aria-pressed]="papelSelecionado === papel.value"
              [pTooltip]="papel.detalhe"
              tooltipPosition="left"
              (click)="setPapel(papel.value)"
            >
              <i [class]="papel.icon"></i>
              <strong>{{ papel.label }}</strong>
              <small>{{ papel.descricao }}</small>
            </button>
          </div>
        </div>

        <div class="field">
          <label>Turno *</label>
          <small class="field-help" *ngIf="turnoBloqueadoId !== null">
            O turno foi definido na alocação do efetivo e não pode ser alterado.
          </small>
          <div class="turno-options">
            <button
              *ngFor="let turno of turnos"
              type="button"
              class="turno-option"
              [class.selected]="+createForm.value.turnoId === +(turno.id || 0)" [attr.aria-pressed]="+createForm.value.turnoId === +(turno.id || 0)"
              [class.locked]="turnoBloqueadoId !== null && turnoBloqueadoId !== +(turno.id || 0)"
              (click)="setTurno(turno)"
            >
              <span class="turno-check"><i class="ri-check-line"></i></span>
              <i [class]="getTurnoIcon(turno)"></i>
              <strong>{{ getTurnoNome(turno.id || 0) }}</strong>
              <small>{{ getTurnoHorario(turno) }}</small>
            </button>
          </div>
          <span *ngIf="loadingTurnos" class="inline-loading">
            <i class="ri-loader-4-line spin"></i>
            A carregar turnos...
          </span>
        </div>

        <div class="turno-insight" *ngIf="createForm.value.turnoId">
          <div class="turno-insight-head">
            <span>
              <i class="ri-group-line"></i>
              Efetivos já neste turno
            </span>
            <strong>{{ turnoOccupantsForCreate.length }}</strong>
          </div>

          <div
            *ngIf="turnoOccupantsForCreate.length; else turnoLivre"
            class="occupant-chips"
          >
            <span
              *ngFor="let membro of turnoOccupantsForCreate | slice: 0 : 8"
              class="occupant-chip"
              [pTooltip]="membro.nome + ' - ' + getPapelLabel(membro.papel)"
              tooltipPosition="top"
            >
              <span class="mini-avatar">
                <img
                  *ngIf="membro.urlFoto"
                  [src]="membro.urlFoto"
                  [alt]="membro.nome"
                />
                <span *ngIf="!membro.urlFoto">{{ getInitials(membro.nome) }}</span>
              </span>
              {{ membro.nome }}
            </span>
          </div>

          <ng-template #turnoLivre>
            <p class="turno-free">
              <i class="ri-checkbox-circle-line"></i>
              Nenhum efetivo encontrado neste turno para o período escolhido.
            </p>
          </ng-template>
        </div>

        <div class="date-grid">
          <div class="field">
            <label for="dataInicio">Primeiro dia *</label>
            <input id="dataInicio" type="date" class="form-input date-input" formControlName="dataInicio" />
          </div>

          <div class="field">
            <label for="dataTermino">Último dia *</label>
            <input id="dataTermino" type="date" class="form-input date-input" formControlName="dataTermino"
              [min]="createForm.value.dataInicio" />
          </div>
        </div>

        <button
          type="button"
          class="add-plan-button"
          [disabled]="!pickerSelected.size"
          (click)="adicionarAoPlano()"
        >
          <i class="ri-add-circle-line"></i>
          <span>
            Adicionar {{ pickerSelected.size || "" }}
            {{ pickerSelected.size === 1 ? "efetivo" : "efetivos" }} ao plano
          </span>
          <i class="ri-arrow-down-line"></i>
        </button>
      </section>

      <section class="create-card plan-card">
        <div class="section-heading plan-heading">
          <span>3</span>
          <div>
            <strong>Rever plano da escala</strong>
            <small>Confira os dias, turnos e efetivos antes de guardar.</small>
          </div>
          <div *ngIf="planoEscala.length" class="plan-stats">
            <span><strong>{{ planoEscala.length }}</strong> dia(s)</span>
            <span><strong>{{ totalAlocacoes }}</strong> alocação(ões)</span>
            <button type="button" (click)="limparPlano()">Limpar</button>
          </div>
        </div>

        <div *ngIf="!planoEscala.length" class="plan-empty">
          <span><i class="ri-route-line"></i></span>
          <div>
            <strong>O plano ainda está vazio</strong>
            <p>
              Selecione efetivos, configure o turno e clique em adicionar ao
              plano. Pode repetir para outros turnos, dias e papeis.
            </p>
          </div>
        </div>

        <div *ngIf="planoEscala.length" class="plan-timeline">
          <article
            *ngFor="let item of planoEscala; trackBy: trackPlano; let last = last"
            class="plan-entry"
            [class.last]="last"
          >
            <div class="timeline-rail">
              <span><i [class]="getTurnoIconById(item.turnoId)"></i></span>
            </div>

            <div class="plan-entry-card">
              <header>
                <div class="plan-when">
                  <span class="plan-date">{{ formatPlanoData(item) }}</span>
                  <strong>{{ getTurnoNome(item.turnoId) }}</strong>
                  <small>{{ formatPlanoHorario(item) }}</small>
                </div>
                <button
                  type="button"
                  class="icon-button danger"
                  pTooltip="Remover este dia"
                  tooltipPosition="left"
                  (click)="removerItemDoPlano(item)"
                >
                  <i class="ri-delete-bin-6-line"></i>
                </button>
              </header>

              <div class="plan-members">
                <div *ngFor="let efetivo of item.efetivos" class="plan-member">
                  <span class="mini-avatar">
                    <img
                      *ngIf="getEfetivoFoto(efetivo.efetivoId)"
                      [src]="getEfetivoFoto(efetivo.efetivoId)"
                      [alt]="getEfetivoNome(efetivo.efetivoId)"
                    />
                    <span *ngIf="!getEfetivoFoto(efetivo.efetivoId)">
                      {{ getEfetivoIniciais(efetivo.efetivoId) }}
                    </span>
                  </span>
                  <span class="member-copy">
                    <strong>{{ getEfetivoNome(efetivo.efetivoId) }}</strong>
                    <small>
                      <i [class]="getPapelIcon(efetivo.papelEfetivoEscalaEnum)"></i>
                      {{ getPapelLabel(efetivo.papelEfetivoEscalaEnum) }}
                    </small>
                  </span>
                  <button
                    type="button"
                    pTooltip="Retirar deste turno"
                    tooltipPosition="top"
                    (click)="removerEfetivoDoPlano(item, efetivo.efetivoId)"
                  >
                    <i class="ri-close-line"></i>
                  </button>
                </div>
              </div>
            </div>
          </article>
        </div>
      </section>
    </div>

    <footer class="dialog-actions">
      <div class="submit-summary">
        <i class="ri-information-line"></i>
        <span *ngIf="planoEscala.length; else faltaPlano">
          Pronto para enviar {{ planoEscala.length }}
          {{ planoEscala.length === 1 ? "requisição" : "requisições" }}.
        </span>
        <ng-template #faltaPlano>Adicione uma alocação para continuar.</ng-template>
      </div>
      <button type="button" class="btn-web-secondary" (click)="closeCreateDialog()">
        Cancelar
      </button>
      <button
        type="submit"
        class="btn-web-primary"
        [disabled]="submitting || !planoEscala.length"
      >
        <i [class]="submitting ? 'ri-loader-4-line spin' : 'ri-check-line'"></i>
        {{ submitting ? "A guardar..." : "Guardar escala" }}
      </button>
    </footer>
  </form>
</p-drawer>

<!-- Drawer: Conflito / Escalas sobrepostas -->
<p-drawer
  [(visible)]="showConflictDrawer"
  [modal]="true"
  position="right"
  appendTo="body"
  [style]="{ width: '500px', maxWidth: '96vw' }"
  styleClass="escala-drawer conflict-drawer"
>
  <ng-template pTemplate="header">
    <div class="drawer-title">
      <span class="drawer-title-icon conflict"><i class="ri-git-merge-line"></i></span>
      <div>
        <h2>Escalas sobrepostas</h2>
        <p>{{ conflitoSlot?.efetivo?.nome }} · {{ conflitoSlot?.data | date:'dd/MM/yyyy' }}</p>
      </div>
    </div>
  </ng-template>

  <div class="conflict-drawer-body">
    <div class="action-warning conflict">
      <i class="ri-alert-line"></i>
      <span>Este efetivo está associado a {{ conflitoSlot?.escalas?.length || 0 }} escalas que abrangem o mesmo dia. Reveja os períodos e corrija a alocação necessária.</span>
    </div>

    <div class="conflict-scale-list">
      <article *ngFor="let escala of conflitoSlot?.escalas; let index = index" class="conflict-scale-card">
        <span class="conflict-scale-index">{{ index + 1 }}</span>
        <div class="conflict-scale-main">
          <div class="conflict-scale-title">
            <span class="conflict-turn-icon"><i [class]="getTurnoIconById(escala.turnoId || 0)"></i></span>
            <div>
              <strong>{{ getTurnoNome(escala.turnoId || 0) }}</strong>
              <small>{{ getConflitoPeriodo(escala) }}</small>
            </div>
            <span class="conflict-state">{{ escala.estado ?? 'Agendada' }}</span>
          </div>
          <div class="conflict-members">
            <span *ngFor="let membro of getConflitoMembros(escala) | slice:0:4">
              <b>{{ getInitials(membro.nome) }}</b>{{ membro.nome }}
            </span>
          </div>
        </div>
        <button type="button" class="conflict-edit-btn" (click)="editarEscalaConflitante(escala)"
          pTooltip="Editar esta escala" tooltipPosition="left">
          <i class="ri-edit-line"></i>
        </button>
      </article>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <footer class="dialog-actions compact">
      <button type="button" class="btn-web-secondary" (click)="showConflictDrawer = false">Fechar</button>
    </footer>
  </ng-template>
</p-drawer>

<!-- Drawer: Registar ou Ver Falta -->
<p-drawer
  [(visible)]="showFaltaDrawer"
  [modal]="true"
  position="right"
  appendTo="body"
  [style]="{ width: 'min(860px, 96vw)' }"
  styleClass="escala-drawer action-drawer falta-action-drawer"
>
  <ng-template pTemplate="header">
    <div class="drawer-title">
      <span class="drawer-title-icon absence"><i class="ri-user-unfollow-line"></i></span>
      <div>
        <h2>{{ faltaEmConsulta ? 'Detalhes da falta' : 'Registar falta' }}</h2>
        <p>{{ faltaEmConsulta ? 'Consulte a classificação, período e justificação.' : 'Escolha a escala, o período e o motivo da ausência.' }}</p>
      </div>
    </div>
  </ng-template>

  <div class="action-drawer-body" [formGroup]="faltaForm">
    <div *ngIf="faltaStandalone && !membroEmEdicao" class="falta-candidate-picker">
      <div class="flow-section-heading">
        <span>1</span>
        <div><strong>Escolha a escala</strong><small>Selecione quem esteve planeado e em que turno.</small></div>
      </div>
      <label class="candidate-search">
        <i class="ri-search-line"></i>
        <input type="search" [ngModel]="faltaCandidateSearch" (ngModelChange)="onFaltaCandidateSearch($event)"
          [ngModelOptions]="{ standalone: true }"
          placeholder="Pesquisar por nome, código, função ou turno..." />
      </label>
      <div class="candidate-results-head">
        <span>Alocações do dia de hoje</span><b>{{ faltaCandidateTotal }}</b>
      </div>
      <div *ngIf="faltaCandidateTotal; else semFaltaCandidates" class="falta-candidate-list">
        <button *ngFor="let candidate of faltaCandidatosPaginados" type="button" class="falta-candidate"
          (click)="selecionarFaltaCandidate(candidate)">
          <span class="member-avatar">
            <img *ngIf="candidate.membro.urlFoto" [src]="candidate.membro.urlFoto" [alt]="candidate.membro.nome" />
            <span *ngIf="!candidate.membro.urlFoto">{{ getInitials(candidate.membro.nome) }}</span>
          </span>
          <span class="candidate-main">
            <strong>{{ candidate.membro.nome }}</strong>
            <small>{{ candidate.membro.cargo || getPapelLabel(candidate.membro.papel) }}{{ candidate.membro.codigo ? ' · ' + candidate.membro.codigo : '' }}</small>
          </span>
          <span class="candidate-period"><i [class]="getTurnoIconById(candidate.turnoId)"></i><strong>{{ candidate.turnoNome }}</strong><small>{{ candidate.periodo }}</small></span>
          <i class="ri-arrow-right-s-line"></i>
        </button>
      </div>
      <div *ngIf="faltaCandidateTotal" class="falta-candidate-pagination">
        <app-paginator-control
          [first]="faltaCandidateFirst"
          [rows]="faltaCandidatePageSize"
          [totalRecords]="faltaCandidateTotal"
          [rowsPerPageOptions]="[5, 10, 20]"
          [alwaysShow]="true"
          [showCurrentPageReport]="true"
          (pageChange)="onFaltaCandidatePageChange($event)"
        ></app-paginator-control>
      </div>
      <ng-template #semFaltaCandidates>
        <div class="falta-candidate-empty">
          <i class="ri-calendar-close-line"></i>
          <strong>Nenhuma alocação prevista para hoje</strong>
          <p>{{ faltaCandidateSearch ? 'Não encontrámos resultados para esta pesquisa.' : 'Não existem escalas previstas para o dia de hoje para registar uma falta.' }}</p>
        </div>
      </ng-template>
    </div>

    <div *ngIf="membroEmEdicao" class="action-person-card selected-for-absence">
      <span class="absence-step-number">1</span>
      <span class="member-avatar">
        <img *ngIf="membroEmEdicao.urlFoto" [src]="membroEmEdicao.urlFoto" [alt]="membroEmEdicao.nome" />
        <span *ngIf="!membroEmEdicao.urlFoto">{{ getInitials(membroEmEdicao.nome) }}</span>
      </span>
      <div><small>EFETIVO E ESCALA SELECIONADOS</small><strong>{{ membroEmEdicao.nome }}</strong><span>{{ getEscalaDiaResumo() }}</span></div>
      <button *ngIf="faltaStandalone && !faltaEmConsulta" type="button" (click)="alterarFaltaCandidate()">Alterar</button>
    </div>

    <ng-container *ngIf="membroEmEdicao">
      <ng-container *ngIf="faltaEmConsulta; else formularioFalta">
        <div *ngIf="loadingFaltaDetalhe" class="falta-detail-loading">
          <p-skeleton *ngFor="let item of [1,2,3]" height="52px" borderRadius="9px"></p-skeleton>
        </div>
        <div *ngIf="!loadingFaltaDetalhe && faltaDetalhe" class="falta-detail-card">
          <div class="falta-detail-status">
            <span><i class="ri-user-unfollow-fill"></i></span>
            <div><small>{{ faltaDetalhe.escala?.postoNome || 'FALTA REGISTADA' }}</small><strong>{{ getTipoFaltaLabel(faltaDetalhe.tipoFaltaEnum) }}</strong></div>
            <b [class.justified]="faltaDetalhe.justificada">{{ faltaDetalhe.justificada ? 'Justificada' : 'Não justificada' }}</b>
          </div>
          <div class="falta-detail-grid">
            <span><small>INÍCIO</small><strong>{{ (faltaDetalhe.dataFaltaInicio || faltaDetalhe.dataInicio) | date:'dd/MM/yyyy' }}</strong></span>
            <span><small>FIM</small><strong>{{ (faltaDetalhe.dataFaltaFim || faltaDetalhe.dataFim) | date:'dd/MM/yyyy' }}</strong></span>
            <span><small>ID DA FALTA</small><strong>#{{ membroEmEdicao?.faltaId }}</strong></span>
            <span><small>ALOCAÇÃO</small><strong>#{{ faltaDetalhe.escalaEfetivo?.id || membroEmEdicao?.escalaEfetivoId }}</strong></span>
            <span><small>TURNO</small><strong>{{ faltaDetalhe.escala?.turnoNome || '--' }}</strong></span>
            <span><small>PAPEL</small><strong>{{ faltaDetalhe.escalaEfetivo?.efetivoEscala || faltaDetalhe.escalaEfetivo?.papelEfetivoEscala || '--' }}</strong></span>
          </div>
          <div class="falta-detail-note">
            <small>OBSERVAÇÃO</small>
            <p>{{ faltaDetalhe.observacao || 'Sem observação registada.' }}</p>
          </div>
        </div>
        <div *ngIf="!loadingFaltaDetalhe && !faltaDetalhe" class="falta-detail-missing">
          <i class="ri-information-line"></i>
          <strong>Falta identificada na escala</strong>
          <p *ngIf="!membroEmEdicao?.faltaId">O backend marcou <code>isFalta/hasFalta</code>, mas ainda não enviou o <code>faltaId</code>.</p>
          <button *ngIf="membroEmEdicao?.faltaId" type="button" (click)="loadFaltaDetalhe()">Tentar novamente</button>
        </div>
      </ng-container>

      <ng-template #formularioFalta>
        <div class="action-warning absence">
          <i class="ri-information-line"></i>
          <span>O turno continua na escala, mas o calendário passará a destacar a falta em vermelho.</span>
        </div>
        <div class="flow-section-heading compact-heading">
          <span>2</span>
          <div><strong>Defina o período</strong><small>Marque um dia, um intervalo ou a semana completa.</small></div>
        </div>
        <div class="falta-mode-selector" role="group" aria-label="Período da falta">
          <button type="button" [class.active]="faltaPeriodoMode === 'single'"
            (click)="setFaltaPeriodoMode('single')">
            <i class="ri-calendar-event-line"></i>
            <span><strong>Apenas este dia</strong><small>Dia clicado no calendário</small></span>
          </button>
          <button type="button" [class.active]="faltaPeriodoMode === 'range'"
            (click)="setFaltaPeriodoMode('range')">
            <i class="ri-calendar-2-line"></i>
            <span><strong>Intervalo de dias</strong><small>Definir início e fim</small></span>
          </button>
          <button type="button" [class.active]="faltaPeriodoMode === 'week'"
            (click)="setFaltaPeriodoMode('week')">
            <i class="ri-calendar-check-line"></i>
            <span><strong>Semana inteira</strong><small>De segunda a domingo</small></span>
          </button>
        </div>
        <div *ngIf="faltaPeriodoMode !== 'range'" class="falta-fixed-period">
          <i [class]="faltaPeriodoMode === 'week' ? 'ri-calendar-check-line' : 'ri-calendar-event-line'"></i>
          <div>
            <small>{{ faltaPeriodoMode === 'week' ? 'PERÍODO DA SEMANA' : 'DIA DA FALTA' }}</small>
            <strong>{{ faltaPeriodoLabel }}</strong>
          </div>
        </div>
        <div *ngIf="faltaPeriodoMode === 'range'" class="falta-period-grid">
          <div class="field">
            <label for="dataFaltaInicio">Início da falta *</label>
            <input id="dataFaltaInicio" type="date" class="form-input date-input" formControlName="dataFaltaInicio" />
          </div>
          <div class="field">
            <label for="dataFaltaFim">Fim da falta *</label>
            <input id="dataFaltaFim" type="date" class="form-input date-input" formControlName="dataFaltaFim" [min]="faltaForm.value.dataFaltaInicio" />
          </div>
        </div>
        <div class="flow-section-heading compact-heading">
          <span>3</span>
          <div><strong>Classifique a ausência</strong><small>Escolha o motivo e acrescente contexto útil.</small></div>
        </div>
        <div class="falta-section-head">
          <label class="action-label">Tipo de falta *</label>
          <button *ngIf="!loadingTiposFalta && !tiposFalta.length" type="button" class="reload-types"
            (click)="loadTiposFalta()"><i class="ri-refresh-line"></i> Tentar novamente</button>
        </div>
        <div *ngIf="loadingTiposFalta" class="falta-types-loading">
          <p-skeleton *ngFor="let item of [1,2,3,4]" height="42px" borderRadius="9px"></p-skeleton>
        </div>
        <div *ngIf="!loadingTiposFalta" class="falta-motivos tipo-falta-grid">
          <button *ngFor="let tipo of tiposFalta" type="button" class="falta-motivo tipo-falta-option"
            [class.active]="faltaForm.value.tipoFaltaEnum === tipo.value"
            (click)="selecionarTipoFalta(tipo)">
            <i [class]="getTipoFaltaIcon(tipo)"></i>
            <span>{{ tipo.label }}</span>
            <i class="ri-check-line selected-check"></i>
          </button>
        </div>

        <button type="button" class="justification-toggle" [class.active]="faltaForm.value.justificada"
          (click)="faltaForm.patchValue({ justificada: !faltaForm.value.justificada })">
          <span><i [class]="faltaForm.value.justificada ? 'ri-checkbox-circle-fill' : 'ri-checkbox-blank-circle-line'"></i></span>
          <div><strong>Falta justificada</strong><small>O efetivo apresentou ou apresentará uma justificação.</small></div>
        </button>

        <div class="field">
          <label for="faltaObservacao">Observação</label>
          <div class="quick-observations">
            <button
              *ngFor="let sugestao of [
                'Não comunicou previamente',
                'Comunicou ao supervisor',
                'Apresentou justificativo',
                'Sem justificativo apresentado',
                'Substituição acionada',
                'Turno coberto por efetivo de reserva'
              ]"
              type="button"
              [class.active]="isObservacaoRapidaAtiva(sugestao)"
              (click)="toggleObservacaoRapida(sugestao)"
            >
              <i [class]="isObservacaoRapidaAtiva(sugestao) ? 'ri-check-line' : 'ri-add-line'"></i>
              {{ sugestao }}
            </button>
          </div>
          <textarea id="faltaObservacao" class="form-input falta-textarea" rows="4" formControlName="observacao"
            maxlength="500" placeholder="Acrescente contexto útil para o histórico..."></textarea>
          <span class="action-char-count">{{ (faltaForm.value.observacao || '').length }}/500</span>
        </div>
      </ng-template>
    </ng-container>
  </div>

  <ng-template pTemplate="footer">
    <footer class="dialog-actions compact action-footer">
      <button *ngIf="faltaEmConsulta && membroEmEdicao?.faltaId" type="button"
        class="btn-remove-falta" [class.confirming]="confirmandoRemoverFalta"
        [disabled]="removingFalta" (click)="removerFalta()">
        <i [class]="removingFalta ? 'ri-loader-4-line spin' : 'ri-delete-bin-6-line'"></i>
        {{ removingFalta ? 'A remover...' : (confirmandoRemoverFalta ? 'Confirmar remoção' : 'Remover falta') }}
      </button>
      <span *ngIf="!faltaEmConsulta" class="action-footer-status" [class.ready]="!!membroEmEdicao && faltaForm.valid">
        <i [class]="!!membroEmEdicao && faltaForm.valid ? 'ri-checkbox-circle-line' : 'ri-information-line'"></i>
        {{ faltaValidationMessage }}
      </span>
      <button type="button" class="btn-web-secondary" (click)="closeFaltaDrawer()">{{ faltaEmConsulta ? 'Fechar' : 'Cancelar' }}</button>
      <button *ngIf="!faltaEmConsulta" type="button" class="btn-falta" [disabled]="submittingFalta || faltaForm.invalid || !membroEmEdicao"
        (click)="registrarFalta()">
        <i [class]="submittingFalta ? 'ri-user-unfollow-fill' : 'ri-user-unfollow-line'"></i>
        {{ submittingFalta ? 'A registar...' : 'Confirmar falta' }}
      </button>
    </footer>
  </ng-template>
</p-drawer>

<!-- Drawer: Retirar Efetivos da Escala -->
<p-drawer
  [(visible)]="showRemoverDrawer"
  [modal]="true"
  position="right"
  appendTo="body"
  [style]="{ width: '520px', maxWidth: '96vw' }"
  styleClass="escala-drawer action-drawer remove-action-drawer"
>
  <ng-template pTemplate="header">
    <div class="drawer-title">
      <span class="drawer-title-icon danger"><i class="ri-user-unfollow-line"></i></span>
      <div><h2>Retirar efetivos da escala</h2><p>Revise o turno e selecione quem deixará de estar planeado.</p></div>
    </div>
  </ng-template>

  <div class="action-drawer-body">
    <div class="removal-context-card">
      <span><i [class]="escalaEmEdicaoTurnoIcon"></i></span>
      <div><small>ESCALA SELECIONADA</small><strong>{{ getEscalaEditTitulo() }}</strong><p>{{ getEscalaDiaResumo() }}</p></div>
      <b>{{ membrosEscala.length }} {{ membrosEscala.length === 1 ? 'efetivo' : 'efetivos' }}</b>
    </div>
    <div class="action-warning danger">
      <i class="ri-alert-line"></i>
      <span><strong>Isto não regista uma falta.</strong> Os selecionados deixam apenas de estar planeados nesta escala.</span>
    </div>
    <div class="removal-toolbar">
      <span><strong>{{ removerSelecionadosIds.size }}</strong> de {{ membrosEscala.length }} selecionado(s)</span>
      <button type="button" (click)="toggleTodosMembrosRemocao()">
        {{ todosMembrosSelecionadosParaRemocao ? 'Limpar seleção' : 'Selecionar todos' }}
      </button>
    </div>
    <div class="removal-list">
      <label *ngFor="let membro of membrosEscala; trackBy: trackMembro" class="removal-row"
        [class.selected]="isMembroSelecionadoParaRemocao(membro)">
        <input type="checkbox" [checked]="isMembroSelecionadoParaRemocao(membro)"
          (change)="toggleMembroRemocao(membro)" />
        <span class="member-avatar">
          <img *ngIf="membro.urlFoto" [src]="membro.urlFoto" [alt]="membro.nome" />
          <span *ngIf="!membro.urlFoto">{{ getInitials(membro.nome) }}</span>
        </span>
        <span><strong>{{ membro.nome }}</strong><small>{{ getPapelLabel(membro.papel) }}{{ membro.codigo ? ' · ' + membro.codigo : '' }}</small></span>
        <i class="ri-check-line"></i>
      </label>
    </div>
    <div *ngIf="removerSelecionadosIds.size" class="removal-impact-summary">
      <i class="ri-user-unfollow-line"></i>
      <div><strong>{{ removerSelecionadosIds.size }} {{ removerSelecionadosIds.size === 1 ? 'efetivo será retirado' : 'efetivos serão retirados' }}</strong><small>{{ membrosEscala.length - removerSelecionadosIds.size }} permanecerá(ão) nesta escala após guardar.</small></div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <footer class="dialog-actions compact action-footer removal-footer">
      <span class="action-footer-status" [class.danger-ready]="removerSelecionadosIds.size">
        <i class="ri-information-line"></i>
        {{ removerSelecionadosIds.size ? 'Revise a seleção antes de confirmar.' : 'Selecione pelo menos um efetivo.' }}
      </span>
      <button type="button" class="btn-web-secondary" (click)="showRemoverDrawer = false">Cancelar</button>
      <button type="button" class="btn-danger-outline" [disabled]="!removerSelecionadosIds.size || removing"
        (click)="confirmarRemocaoNoDrawer()">
        <i [class]="removing ? 'ri-loader-4-line spin' : 'ri-user-unfollow-line'"></i>
        {{ removing ? 'A retirar...' : (removerSelecionadosIds.size === 1 ? 'Retirar 1 efetivo' : (removerSelecionadosIds.size > 1 ? 'Retirar ' + removerSelecionadosIds.size + ' efetivos' : 'Retirar efetivo')) }}
      </button>
    </footer>
  </ng-template>
</p-drawer>

<!-- Drawer: Editar Escala -->
<p-drawer
  [(visible)]="showEditDialog"
  (onHide)="closeEditDialog()"
  [modal]="true"
  position="right"
  appendTo="body"
  [style]="{ width: '1000px', maxWidth: '98vw' }"
  styleClass="escala-drawer escala-edit-drawer"
>
  <ng-template pTemplate="header">
    <div class="drawer-title">
      <span class="drawer-title-icon edit">
        <i class="ri-edit-2-line"></i>
      </span>
      <div>
        <h2>{{ getEscalaEditTitulo() }}</h2>
        <p>Veja o histórico do dia, marque faltas e ajuste a escala.</p>
      </div>
    </div>
  </ng-template>

  <form
    *ngIf="escalaEmEdicao"
    [formGroup]="editForm"
    (ngSubmit)="submitEditEscala()"
  >
    <!-- Alerta Informativo sobre Bloqueio de Edição -->
    <div *ngIf="!podeEditarOuEliminarEscala(escalaEmEdicao)" class="action-warning danger edit-blocked-warning">
      <i class="ri-lock-2-line"></i>
      <span><strong>Esta escala não pode ser editada nem eliminada.</strong> O turno está em curso ou já foi concluído. O histórico foi mantido para fins de registo operacional.</span>
    </div>

    <div class="edit-grid">
      <section class="edit-panel edit-config-panel">
        <div class="edit-step-heading">
          <span>1</span>
          <div><strong>Configuração da escala</strong><small>Ajuste o turno, período, estado e papel do efetivo selecionado.</small></div>
        </div>
        <div class="edit-summary-card">
          <span class="summary-icon">
            <i [class]="selectedEditTurno ? getTurnoIcon(selectedEditTurno) : 'ri-time-line'"></i>
          </span>
          <div>
            <span class="toolbar-eyebrow">Escala selecionada</span>
            <strong>{{ getEscalaEditTitulo() }}</strong>
            <small>
              {{ membrosEscala.length }}
              {{ membrosEscala.length === 1 ? "efetivo neste turno" : "efetivos neste turno" }}
            </small>
          </div>
        </div>

        <div class="slot-day-strip">
          <i class="ri-calendar-event-line"></i>
          <span>{{ getEscalaDiaResumo() }}</span>
        </div>

        <div class="field">
          <label>Turno *</label>
          <div class="turno-options edit-turnos">
            <button
              *ngFor="let turno of turnos"
              type="button"
              class="turno-option"
              [class.selected]="+editForm.value.turnoId === +(turno.id || 0)" [attr.aria-pressed]="+editForm.value.turnoId === +(turno.id || 0)"
              (click)="setEditTurno(turno)"
            >
              <span class="turno-check"><i class="ri-check-line"></i></span>
              <i [class]="getTurnoIcon(turno)"></i>
              <strong>{{ getTurnoNome(turno.id || 0) }}</strong>
              <small>{{ getTurnoHorario(turno) }}</small>
            </button>
          </div>
        </div>

        <div class="date-grid edit-date-grid">
          <div class="field">
            <label for="editDataInicio">Dia inicial *</label>
            <input
              id="editDataInicio"
              type="date"
              class="form-input"
              formControlName="dataInicio"
            />
          </div>

          <div class="field">
            <label for="editDataTermino">Dia final *</label>
            <input
              id="editDataTermino"
              type="date"
              class="form-input"
              formControlName="dataTermino"
              [min]="editForm.value.dataInicio"
            />
          </div>
        </div>

        <div class="field edit-papel-field">
          <label for="editPapel">
            Papel de {{ membroEmEdicao?.nome || "efetivo" }}
          </label>
          <p-select
            id="editPapel"
            [options]="papeisEscala"
            formControlName="papelEfetivoEscalaEnum"
            optionLabel="label"
            optionValue="value"
            [filter]="true"
            appendTo="body"
            placeholder="Selecione o papel"
          ></p-select>
        </div>

        <div class="field">
          <label>Estado</label>
          <p-select
            [options]="estadosEscala"
            formControlName="estado"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            placeholder="Estado da escala"
          >
            <ng-template pTemplate="selectedItem" let-option>
              <span class="estado-select-item">
                <i [class]="option?.icon"></i>
                {{ option?.label }}
              </span>
            </ng-template>
            <ng-template pTemplate="item" let-option>
              <span class="estado-select-item">
                <i [class]="option.icon"></i>
                {{ option.label }}
              </span>
            </ng-template>
          </p-select>
        </div>
      </section>

      <section class="edit-panel edit-team-panel">
        <div class="section-heading member-heading">
          <span>2</span>
          <div>
            <strong>Efetivos deste turno</strong>
            <small>Escolha um efetivo para editar o papel ou marcar falta.</small>
          </div>
        </div>

        <div class="member-list">
          <article
            *ngFor="let membro of membrosEscala; trackBy: trackMembro"
            class="member-row"
            [class.active]="membroEmEdicaoId === membro.efetivoId"
          >
            <button
              type="button"
              class="member-main"
              [attr.aria-pressed]="membroEmEdicaoId === membro.efetivoId"
              (click)="selecionarMembroParaEditar(membro)"
            >
              <span class="member-avatar">
                <img
                  *ngIf="membro.urlFoto"
                  [src]="membro.urlFoto"
                  [alt]="membro.nome"
                />
                <span *ngIf="!membro.urlFoto">{{ getInitials(membro.nome) }}</span>
              </span>
              <span class="member-copy">
                <strong>{{ membro.nome }}</strong>
                <small>
                  <i [class]="getPapelIcon(membro.papel)"></i>
                  {{ getPapelLabel(membro.papel) }}
                  <ng-container *ngIf="membro.codigo"> - {{ membro.codigo }}</ng-container>
                </small>
              </span>
              <span *ngIf="membro.isFalta" class="member-falta-badge"><i class="ri-user-unfollow-line"></i> Falta</span>
              <span class="member-selection-indicator"><i class="ri-check-line"></i></span>
            </button>

          </article>
        </div>

        <div class="member-actions">
          <button 
            type="button" 
            class="btn-web-secondary" 
            [disabled]="!podeEditarOuEliminarEscala(escalaEmEdicao)"
            (click)="adicionarEfetivosAoTurnoAtual()"
          >
            <i class="ri-user-add-line"></i> Adicionar efetivos
          </button>

          <!-- Exibido apenas se for o dia de início do turno (podeRegistarFaltaNoSlot) OU se já existir falta registada -->
          <button
            *ngIf="podeRegistarFaltaNoSlot || escalaTemFalta"
            type="button"
            class="btn-web-secondary warning"
            [disabled]="!membroEmEdicao"
            (click)="abrirDrawerFalta()"
          >
            <i [class]="escalaTemFalta ? 'ri-user-unfollow-fill' : 'ri-user-unfollow-line'"></i>
            {{ escalaTemFalta ? 'Ver falta' : 'Registar falta' }}
          </button>

          <button 
            type="button" 
            class="btn-danger-outline" 
            [disabled]="!membroEmEdicao || !podeEditarOuEliminarEscala(escalaEmEdicao)" 
            (click)="abrirDrawerRemocao()"
          >
            <i class="ri-delete-bin-6-line"></i> Remover
          </button>
        </div>

        <div *ngIf="escalaTemFalta" class="action-warning absence edit-blocked-warning">
          <i class="ri-lock-line"></i>
          <span>Este efetivo tem uma falta registada. Remova a falta antes de alterar o turno, o período ou o papel.</span>
        </div>

        <section class="scale-side-card history-card">
          <header>
            <span>
              <i class="ri-history-line"></i>
              Histórico recente desta escala
            </span>
            <button
              type="button"
              class="icon-button"
              pTooltip="Atualizar histórico"
              tooltipPosition="top"
              (click)="loadHistoricoEscala()"
            >
              <i [class]="loadingHistoricoEscala ? 'ri-loader-4-line spin' : 'ri-refresh-line'"></i>
            </button>
          </header>

          <app-escala-historico
            [items]="historicoEscala"
            [loading]="loadingHistoricoEscala"
            [compact]="true"
          ></app-escala-historico>
        </section>

      </section>
    </div>

    <footer class="dialog-actions">
      <div class="submit-summary">
        <i class="ri-information-line"></i>
        <span>
          Guardar altera o turno, período e papel de
          <strong>{{ membroEmEdicao?.nome || "um efetivo" }}</strong>.
        </span>
      </div>
      <button type="button" class="btn-web-secondary" (click)="closeEditDialog()">
        Fechar
      </button>
      <button
        type="submit"
        class="btn-web-primary"
        [disabled]="editSubmitting || editForm.invalid || escalaTemFalta || !podeEditarOuEliminarEscala(escalaEmEdicao)"
      >
        <i [class]="editSubmitting ? 'ri-loader-4-line spin' : 'ri-save-3-line'"></i>
        {{ editSubmitting ? "A guardar..." : "Guardar alterações" }}
      </button>
    </footer>
  </form>
</p-drawer>